import { em, math } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${em(220)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
    min-height: ${p => p.theme.blocks.heightBlockDarkBlue};
  }
`

export const Dna = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: ${em(220)};
  overflow: hidden;

  ${p => p.theme.mq.upMd} {
    // 20 - extra indent for safety
    top: ${p => math(`-${em(40)} - ${p.theme.buttons.hActionBtn} - ${em(20)}`)};
    right: ${p => math(`${em(p.theme.indents.baseIndentMd)} + ${em(40)}`)};
    height: auto;
    width: ${em(220)};
  }

  ${p => p.theme.mq.upLg} {
    right: ${p => p.theme.indents.baseBoxIndentLg};
    transform: translateX(-50%);
  }
`

export const DnaImage = styled.img`
  position: relative;
  right: -140%;
  width: ${em(220)};
  height: auto;
  transform: rotate(90deg);
  transform-origin: 0 0;

  ${p => p.theme.mq.upMd} {
    right: 0;
    transform: none;
  }
`

export const Article = styled.article`
  padding-bottom: ${em(40)};
`
